<template>
  <div v-if="checkPermission(c_permission)" class="d-inline">
    <b-button style="white-space: nowrap;" :class="classButton"   :id="id"  :to="to" @click.prevent="$emit('click')" size="sm" :variant="variant" :disabled="disabledButton">
        <i :class="classValue"
           aria-hidden="true"></i>
        <slot></slot>
    </b-button>
  </div>
</template>

<script>
    export default {
        name: "AppButton",
        props: {
            loading: {
                type: Boolean,
                default: false
            },
            variant: {
                type: String,
                default: 'primary'
            },
            icon: {
                type: String
            },
            id: {
                type: String,
                default: ''
            },
          to: {
            type: Object,
            default: null
          },
          c_permission: {
              type: Number
          },
          button_type:{
              type:String
          },
          disabled:{
              type:Boolean,
              default:false
          }

        },
        computed: {
            classValue(){
                return !this.loading ? this.icon : 'fa fa-spinner fa-spin fa-fw'
            },
            classButton(){
              return this.button_type === 'new' ? 'button-new': ''
            },
            disabledButton(){
              return this.disabled || this.loading
            }
        },
    }
</script>

<style scoped>

</style>
